import { MessageTemplate } from '@/features/messages/MessageTemplate';
import { DriverMessage } from '@/features/messages/DriverMessage';
import { TransportType } from '@/features/shared/models/TransportType';

export const IDriverMessagesServiceId = Symbol.for('IDriverMessagesServiceId');

export interface IDriverMessagesService {
    getTemplates(transportType: TransportType): Promise<MessageTemplate[] | null>;

    sendMessage(message: DriverMessage): Promise<void>;
}
